import { defineMessages } from 'react-intl';
export function isPastWorker(worker) {
    const workerState = normalizeWorkerLifecycleState(worker.state);
    if (workerState === 'error')
        return true;
    const agentTurnState = normalizeAgentTurnState(worker.thread?.status);
    const displayStatus = getWorkerDisplayStatus({
        agentTurnState,
        workerState,
    });
    if (displayStatus === 'working')
        return false;
    return displayStatus === 'finished' || agentTurnState === 'completed';
}
export function getAgentTaskStatus(worker) {
    if (!worker || worker.workerState === 'error')
        return 'unknown';
    const displayStatus = getWorkerDisplayStatus(worker);
    if (displayStatus === 'working')
        return 'active';
    if (worker.agentTurnState === 'completed')
        return 'finished';
    return displayStatus === 'finished' ? 'unknown' : 'active';
}
export function getWorkerDisplayStatus({ agentTurnState, workerState, }) {
    // Resumable workers can outlive their legacy creation-based expiry.
    if (workerState === 'retiring' || workerState === 'retired')
        return 'finished';
    // ERROR is terminal: the runtime failed and cannot be resumed, so there is nothing to answer.
    if (workerState === 'error')
        return 'failed';
    if (agentTurnState === 'blocked')
        return 'needs-attention';
    if (workerState === 'pausing' || workerState === 'paused' || agentTurnState === 'sleeping') {
        return 'paused';
    }
    if (workerState === 'creating' || workerState === 'resuming' || agentTurnState === 'pending') {
        return 'working';
    }
    return 'ready';
}
export function normalizeWorkerRuntime(runtime) {
    switch (runtime) {
        case 'SANDBOX':
            return 'sandbox';
        case 'DEVBOX':
            return 'devbox';
        case 'LOCAL':
            return 'local';
        default:
            return null;
    }
}
export function normalizeWorkerLifecycleState(state) {
    switch (state) {
        case 'CREATING':
            return 'creating';
        case 'RUNNING':
            return 'running';
        case 'PAUSING':
            return 'pausing';
        case 'PAUSED':
            return 'paused';
        case 'RESUMING':
            return 'resuming';
        case 'RETIRING':
            return 'retiring';
        case 'RETIRED':
            return 'retired';
        case 'ERROR':
        default:
            return 'error';
    }
}
export function normalizeAgentTurnState(status) {
    switch (status) {
        case 'PENDING':
            return 'pending';
        case 'BLOCKED':
            return 'blocked';
        case 'COMPLETED':
            return 'completed';
        case 'SLEEPING':
            return 'sleeping';
        case 'UNKNOWN':
            return 'unknown';
        default:
            return null;
    }
}
const WORKER_REASONING_EFFORT_LABELS = defineMessages({
    minimal: {
        defaultMessage: 'Minimal',
        description: 'Minimal reasoning effort option',
        id: 'e2cb6aca26',
    },
    low: { defaultMessage: 'Low', description: 'Low reasoning effort option', id: '06327bdf63' },
    medium: {
        defaultMessage: 'Medium',
        description: 'Medium reasoning effort option',
        id: '2a2826fdcc',
    },
    high: { defaultMessage: 'High', description: 'High reasoning effort option', id: '05d72d008e' },
    xhigh: {
        defaultMessage: 'Extra High',
        description: 'Extra-high reasoning effort option',
        id: 'af781e49e9',
    },
    max: { defaultMessage: 'Max', description: 'Maximum reasoning effort option', id: '0a08e792ab' },
});
export function getWorkerReasoningEffortLabel(reasoningEffort, intl) {
    const labels = WORKER_REASONING_EFFORT_LABELS;
    const message = reasoningEffort ? labels[reasoningEffort] : undefined;
    return message ? intl.formatMessage(message) : null;
}
//# sourceMappingURL=workerModel.js.map